import React from "react";

import "./styles/index.scss";

type CustomErrorMessageProps = {
  message?: string;
};

const CustomErrorMessage = ({ message }: CustomErrorMessageProps) => {
  const messageText =
    message || "An error occurred. Please try again or contact support.";

  return <div className="error-message">{messageText}</div>;
};

export default CustomErrorMessage;
